import { AuthorizationPatch } from '#authorization/model'
import { avlType } from '#avl/constants'
import { DetailsPatch } from '#details/model'
import { PhotographsPatch } from '#photographs/model'
import { GenericRecord, RecordPatch, RecordSlot } from '#record/model'
import { TagReference } from 'apprise-core/tag'
import { TenantReference } from 'apprise-core/tenant'
import { utils } from 'apprise-core/utils'
import { DeepPartial } from 'apprise-core/utils'

export type AvlPatch = DetailsPatch & AuthorizationPatch & PhotographsPatch & RecordPatch<typeof avlType>


export type AvlDeclarations = RecordSlot & {

    declarations: AvlDeclaration[]

}


//eslint-disable-next-line
export type AvlDeclaration = {

    species: TagReference
    year: string
    tenant: TenantReference
    charterer: Charterer
    revoked?: Revocation


}

export type Revocation = {
    revokedOn: string
    revokedBy: string
    comment?: string
}

export type Charterer = {
    name: string
    address: string
}

export const newAvlSlot = () => {

    const partials: DeepPartial<AvlDeclarations> = {

        id: utils().mint('AVL'),
        declarations: []

    }

    return partials as AvlDeclarations
}

export const isAvlRecord = (r: GenericRecord | undefined) => !!r?.[avlType]